var map = {
	"./ar.js": [
		"./node_modules/@amcharts/amcharts4/lang/ar.js",
		"amchart-lang-ar-js"
	],
	"./bs_BA.js": [
		"./node_modules/@amcharts/amcharts4/lang/bs_BA.js",
		"amchart-lang-bs_BA-js"
	],
	"./ca_ES.js": [
		"./node_modules/@amcharts/amcharts4/lang/ca_ES.js",
		"amchart-lang-ca_ES-js"
	],
	"./cs_CZ.js": [
		"./node_modules/@amcharts/amcharts4/lang/cs_CZ.js",
		"amchart-lang-cs_CZ-js"
	],
	"./da_DK.js": [
		"./node_modules/@amcharts/amcharts4/lang/da_DK.js",
		"amchart-lang-da_DK-js"
	],
	"./de_CH.js": [
		"./node_modules/@amcharts/amcharts4/lang/de_CH.js",
		"amchart-lang-de_CH-js"
	],
	"./de_DE.js": [
		"./node_modules/@amcharts/amcharts4/lang/de_DE.js",
		"amchart-lang-de_DE-js"
	],
	"./el_GR.js": [
		"./node_modules/@amcharts/amcharts4/lang/el_GR.js",
		"amchart-lang-el_GR-js"
	],
	"./en.js": [
		"./node_modules/@amcharts/amcharts4/lang/en.js",
		"amchart-lang-en-js"
	],
	"./en_CA.js": [
		"./node_modules/@amcharts/amcharts4/lang/en_CA.js",
		"amchart-lang-en_CA-js"
	],
	"./en_US.js": [
		"./node_modules/@amcharts/amcharts4/lang/en_US.js",
		"amchart-lang-en_US-js"
	],
	"./es_ES.js": [
		"./node_modules/@amcharts/amcharts4/lang/es_ES.js",
		"amchart-lang-es_ES-js"
	],
	"./et_EE.js": [
		"./node_modules/@amcharts/amcharts4/lang/et_EE.js",
		"amchart-lang-et_EE-js"
	],
	"./fi_FI.js": [
		"./node_modules/@amcharts/amcharts4/lang/fi_FI.js",
		"amchart-lang-fi_FI-js"
	],
	"./fr_FR.js": [
		"./node_modules/@amcharts/amcharts4/lang/fr_FR.js",
		"amchart-lang-fr_FR-js"
	],
	"./he_IL.js": [
		"./node_modules/@amcharts/amcharts4/lang/he_IL.js",
		"amchart-lang-he_IL-js"
	],
	"./hi_IN.js": [
		"./node_modules/@amcharts/amcharts4/lang/hi_IN.js",
		"amchart-lang-hi_IN-js"
	],
	"./hr_HR.js": [
		"./node_modules/@amcharts/amcharts4/lang/hr_HR.js",
		"amchart-lang-hr_HR-js"
	],
	"./hu_HU.js": [
		"./node_modules/@amcharts/amcharts4/lang/hu_HU.js",
		"amchart-lang-hu_HU-js"
	],
	"./id_ID.js": [
		"./node_modules/@amcharts/amcharts4/lang/id_ID.js",
		"amchart-lang-id_ID-js"
	],
	"./it_IT.js": [
		"./node_modules/@amcharts/amcharts4/lang/it_IT.js",
		"amchart-lang-it_IT-js"
	],
	"./ja_JP.js": [
		"./node_modules/@amcharts/amcharts4/lang/ja_JP.js",
		"amchart-lang-ja_JP-js"
	],
	"./ko_KR.js": [
		"./node_modules/@amcharts/amcharts4/lang/ko_KR.js",
		"amchart-lang-ko_KR-js"
	],
	"./lt_LT.js": [
		"./node_modules/@amcharts/amcharts4/lang/lt_LT.js",
		"amchart-lang-lt_LT-js"
	],
	"./lv_LV.js": [
		"./node_modules/@amcharts/amcharts4/lang/lv_LV.js",
		"amchart-lang-lv_LV-js"
	],
	"./nb_NO.js": [
		"./node_modules/@amcharts/amcharts4/lang/nb_NO.js",
		"amchart-lang-nb_NO-js"
	],
	"./nl_NL.js": [
		"./node_modules/@amcharts/amcharts4/lang/nl_NL.js",
		"amchart-lang-nl_NL-js"
	],
	"./pl_PL.js": [
		"./node_modules/@amcharts/amcharts4/lang/pl_PL.js",
		"amchart-lang-pl_PL-js"
	],
	"./pt_BR.js": [
		"./node_modules/@amcharts/amcharts4/lang/pt_BR.js",
		"amchart-lang-pt_BR-js"
	],
	"./pt_PT.js": [
		"./node_modules/@amcharts/amcharts4/lang/pt_PT.js",
		"amchart-lang-pt_PT-js"
	],
	"./ro_RO.js": [
		"./node_modules/@amcharts/amcharts4/lang/ro_RO.js",
		"amchart-lang-ro_RO-js"
	],
	"./ru_RU.js": [
		"./node_modules/@amcharts/amcharts4/lang/ru_RU.js",
		"amchart-lang-ru_RU-js"
	],
	"./sk_SK.js": [
		"./node_modules/@amcharts/amcharts4/lang/sk_SK.js",
		"amchart-lang-sk_SK-js"
	],
	"./sl_SL.js": [
		"./node_modules/@amcharts/amcharts4/lang/sl_SL.js",
		"amchart-lang-sl_SL-js"
	],
	"./sr_RS.js": [
		"./node_modules/@amcharts/amcharts4/lang/sr_RS.js",
		"amchart-lang-sr_RS-js"
	],
	"./sv_SE.js": [
		"./node_modules/@amcharts/amcharts4/lang/sv_SE.js",
		"amchart-lang-sv_SE-js"
	],
	"./th_TH.js": [
		"./node_modules/@amcharts/amcharts4/lang/th_TH.js",
		"amchart-lang-th_TH-js"
	],
	"./tr_TR.js": [
		"./node_modules/@amcharts/amcharts4/lang/tr_TR.js",
		"amchart-lang-tr_TR-js"
	],
	"./uk_UA.js": [
		"./node_modules/@amcharts/amcharts4/lang/uk_UA.js",
		"amchart-lang-uk_UA-js"
	],
	"./vi_VN.js": [
		"./node_modules/@amcharts/amcharts4/lang/vi_VN.js",
		"amchart-lang-vi_VN-js"
	],
	"./zh_Hans.js": [
		"./node_modules/@amcharts/amcharts4/lang/zh_Hans.js",
		"amchart-lang-zh_Hans-js"
	],
	"./zh_Hant.js": [
		"./node_modules/@amcharts/amcharts4/lang/zh_Hant.js",
		"amchart-lang-zh_Hant-js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./node_modules/@amcharts/amcharts4/lang lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;